import Course from '@/content/models/course.model';
import { SECTION_TYPES } from '@/content/values/sections';
import { IParamsCourseObject } from '@/courses/interfaces/params-course-object.interface';
import { IParamsCreateTypeObject } from '@/courses/interfaces/params-create-type-object.interface';
import { IResultCreateTypeObject } from '@/courses/interfaces/result-create-type-object.interface';
import { CourseCreateSplitObjectMixin } from '@/courses/mixins/course-create-split-object.mixin';
import { CreateObjectsMixin } from '@/courses/mixins/create-objects.mixin';
import Component from 'vue-class-component';
import { Mixins, Prop } from 'vue-property-decorator';
import EdCreateTypeObject from '../ed-create-type-object/ed-create-type-object.vue';

@Component({
  components: {
    EdCreateTypeObject
  }
})
export default class EdCourseCreateTypeObject extends Mixins(CreateObjectsMixin, CourseCreateSplitObjectMixin) {

  // @Prop() readonly params: IParamsCourseObject;   //Typescript upgrade
  declare readonly params: IParamsCourseObject;
  
  public createParams: IParamsCreateTypeObject = {
    edition: false,
    title: '',
    labelSections: null,
  };

  public EdCreateTypeObject: any = null;

  get course(): Course {
    return this.getCourseFromStore({courseId: this.params.courseId , classId: this.params.classId });
  }

  onSave(result: IResultCreateTypeObject) {

    this.EdCreateTypeObject = this.$refs.EdCreateTypeObject;
    this.EdCreateTypeObject.setSaving(true);

    let question = {
      document: result.question,
      previous: this.createParams.problem,
      typePdf: SECTION_TYPES.SPLIT_QUESTION_PDF.code,
      typeMaterial: SECTION_TYPES.SPLIT_QUESTION_MATERIAL.code
    };
    let solution = {
      document: result.solution,
      previous: this.createParams.solution,
      typePdf: SECTION_TYPES.SPLIT_SOLUTION_PDF.code,
      typeMaterial: SECTION_TYPES.SPLIT_SOLUTION_MATERIAL.code
    };
    let payload = new FormData();
    let submissionDates: any = {
      dueSchoolDay: this.getSchoolDayIndex(result.dueDate),
      dueDate: result.dueDate,
      lastSchoolDay: this.getSchoolDayIndex(result.lastDate),
      lastDate: result.lastDate,
      dueDateAuto: result.dueDateAuto,
      lastDateAuto: result.lastDateAuto
    }
    let section: any = {
      name: result.name,
      question: this.getDocumentToSave(question),
      solution: result.solution.data ? this.getDocumentToSave(solution) : null,
      numberAnswer: result.answers,
      answerPoints: result.answerPoints,
      homeworkWeight: result.homeworkWeight,
      sectionMaterialQuestion: this.getDocumentSectionMaterial(question),
      sectionMaterialSolution: result.solution.data ? this.getDocumentSectionMaterial(solution) : null,
      type: SECTION_TYPES.LESSON_SPLIT_TYPE.code,
      labelSections: result.labelSections,
      ...submissionDates,
      submissionDates,
      component: result.component
    };

    /* Resources */
    payload = this.setResource(payload, result.question, 'questionResource');
    payload = this.setResource(payload, result.solution, 'solutionResource');

    if(this.params.edition) {
      this.updateTypeObject(payload, section, result.edition);
    } else {
      this.saveTypeObject(section, payload);
    }

  }

  updateTypeObject(payload: FormData, section: any, edition: any) {

    let comp: any = this.$refs.EdCreateWriteObject;
    section.id = this.params.section.sectionId;
    
    /* Update question */
    if(!edition.deleteQuestion) {
      section.question.id = this.createParams.problem.data?.id;
    }
    
    /* Update solution */
    if(section.solution) {
      if(!edition.deleteSolution) {
        section.solution.id = this.createParams.solution.data?.id;
      } 
    }

    /* Remove previous resources */
    if(edition.deleteQuestion) {
      section.deleteQuestion = this.createParams.problem.data?.id;
    }
    if(edition.deleteSolution) {
      section.deleteSolution = this.createParams.solution.data?.id;
    }

    payload.append('section', JSON.stringify(section)); 
    this.updateSplitObject(
      payload,
      this.params.parentId,
      this.params.courseId,
      this.params.classId,
      this.params.section.sectionId
    ).then(() => {
      this.$EdModal.closeModal();
    }).catch(() => {
      this.EdCreateTypeObject.setSaving(false);
    });
  }

  saveTypeObject(section: any, payload: FormData) {
    payload.append('section', JSON.stringify(section));
    this.saveSplitObject(
      payload,
      this.params.parentId,
      this.params.courseId,
      this.params.classId
    ).then(
      () => {
        this.$EdModal.closeModal();
      }
    ).catch(() => {
      this.EdCreateTypeObject.setSaving(false);
    });
  }

  onClose() {
    this.$EdModal.closeModal();
  }

  setCreateParamsEdition() {
    let section = this.params.section;
    let dates = section.submissionDates || {};
    let documents = this.getProblemSolutionForEdition(section.sections);
    this.createParams.resolved = section.resolved;
    this.createParams.edition = true;
    this.createParams.name = section.name;
    let answerInfo = JSON.parse(section.text)
    this.createParams.answers = Number(answerInfo.answers);
    this.createParams.answerPoints = answerInfo.answerPoints;
    this.createParams.homeworkWeight = section.homeworkWeight;
    this.createParams.hasBeenResolvedByAnyStudent = section.hasBeenResolvedByAnyStudent;
    this.createParams.problem = documents.problem;
    this.createParams.solution = documents.solution;
    this.createParams.submissionDates = this.params.section.submissionDates;
    this.createParams.labelSections = this.params.section.labelSections;
    this.createParams.component = this.params.section.component;
    this.createParams.courseId = this.params.courseId;
  }

  created() {
    let title = this.params.edition ? 'edit' : 'create';
    if(this.params.edition) {
      this.setCreateParamsEdition();
    }
    this.createParams.hasTagSelector = this.params.contentType === 'TEMPLATE';
    this.createParams.minDate = this.params.minDate;
    this.createParams.courseId = this.params.courseId;
    this.createParams.title = String(this.$i18n.t(`courses.typeObject.${title}TypeObject`));
  }

}